import { httpGet, httpPost, normalHttpPost, IResponse } from '../network';
import {
  BOOKED_APOINTMENTS_API,
  BOOK_APPOINTMENT_API,
  BOOK_APPOINTMENT_BY_PATIENT_API,
  REBOOK_APPOINTMENT_API,
  APPOINTMENTS_API,
  TODAYS_PATIENTS,
  UPDATE_PAYMENT_STATUS,
  UPDATE_CONSULT_STATUS,
  UPDATE_TAGS,
  UPDATE_PATIENT_INFO,
  GET_CONSULTED_DATES,
  SEND_CONSUTING_TIME_CHANGE_SMS,
  CONSULT_DATE_CHANGED,
  REBOOK_APPOINTMENT_BY_PATIENT_API
} from '../../constants/api';
import { TAppointment } from '../../types/appointment';
export const getBookedAppointments = (
  querystrings: string
) => {
  return httpGet<TAppointment[]>(BOOKED_APOINTMENTS_API + '?' + querystrings);
};
export const bookAppointment = <T>(data: any): Promise<IResponse<T>> => {
  return httpPost<T>(BOOK_APPOINTMENT_API, data);
};
export const bookAppointmentByPatient = <T>(data: any): Promise<IResponse<T>> => {
  return httpPost<T>(BOOK_APPOINTMENT_BY_PATIENT_API, data);
};
export const rebookAppointment = <T>(data: any): Promise<IResponse<T>> => {
  return httpPost<T>(REBOOK_APPOINTMENT_API, data);
}
export const rebookAppointmentByPatient = <T>(data: any): Promise<IResponse<T>> => {
  return httpPost<T>(REBOOK_APPOINTMENT_BY_PATIENT_API, data);
}
export const getAppointments = <T>(data: any): Promise<IResponse<T>> => {
  return normalHttpPost<T>(APPOINTMENTS_API, data);
};
export const fetchTodaysPatients = (doctor_id: number) => {
  return httpGet<{ appointments: Record<string, TAppointment[]>, consult_dates: string[] }>(`${TODAYS_PATIENTS}?doctor_id=${doctor_id}`)
}
export const updatePaymentStatusPostcurl = (data: any) => {
  return httpPost<{ total_amount: number, booking_charge: number, payment_status: string }>(UPDATE_PAYMENT_STATUS, data);
}
export const updateConsultStatusPostCurl = (data: any) => {
  return httpPost<{ status: string }>(UPDATE_CONSULT_STATUS, data);
}
export const updateBookingTagsPostcurl = (data: { booking_id: number; doctor_id: number; service_loc_id: number; user_id: number; tags: string[] }) => {
  return httpPost<{ tags: string[] }>(UPDATE_TAGS, data);
}
export type TPatientInfo = { patient_name: string; patient_age: string; patient_address: string };
/* patient_age is optional on the way out: leaving it off tells the api the age was not touched, and
   that column is then left as it is rather than written over with the value it already holds */
export const updatePatientInfoPostcurl = (data: Omit<TPatientInfo, 'patient_age'> & { patient_age?: string; booking_id: number; doctor_id: number; patient_id: number | null }) => {
  return httpPost<Partial<TPatientInfo>>(UPDATE_PATIENT_INFO, data);
}
export const sendDoctorConsultingTimeChangeSMSPostcurl=(data: any)=>{
  return httpPost<{ status: string }>(SEND_CONSUTING_TIME_CHANGE_SMS, data);
}
export const consultDateChanged=(data:any)=>{
  return httpPost(CONSULT_DATE_CHANGED,data)
}
export type TconsutedDate = {
  booking_count: number
  consult_date: string
  month: number
  month_name: string
  year: number
}
export const getConsultedDates = (doctor_id: number): Promise<IResponse<TconsutedDate[]>> => {
  return httpGet(GET_CONSULTED_DATES + `?doctor_id=${doctor_id}`)
}